// 用户账户详情
export function accountInfo (params) {
  return $api.get('/s1/user.account', { params: params })
}
// 微信提现
export function wechatWithdraw (params) {
  return $api.post('/s1/user.withdraw.wechat', params)
}
// 我的队员-按日期
export function memberDateList (params) {
  return $api.get('/s1/user.members_by_date', { params: params })
}
// 我的队员-按收入
export function memberIncomeList (params) {
  return $api.get('/s1/user.members_by_income', { params: params })
}
// 我的提成
export function getCommision (params) {
  return $api.get('/s1/user.teamReward', { params: params })
}
// 更多提成
export function getMoreCommission (params) {
  return $api.get('/s1/user.teamReward_by_tab', { params: params })
}
// 团队提成
export function teamReward (params) {
  return $api.get('/s1/team.draw_reward', { params: params })
}
